<template>
  <div>
    <FormHeading>POLICYHOLDER DISCLOSURE</FormHeading>
    <FormHeading>NOTICE OF TERRORISM INSURANCE COVERAGE</FormHeading>
    <P>
      You are hereby notified that under the Terrorism Risk Insurance Act of 2002 as 
      amended and extended by the Terrorism Risk Insurance Program Reauthorization Act of 2019,  
      that you have a right to purchase insurance coverage for losses resulting from acts of terrorism, 
      as defined in Section 102(1): The term “act of terrorism” means any act that is certified by 
      the Secretary of the Treasury—in consultation with the Secretary of Homeland Security, 
      and the Attorney General of the United States—as meeting all of the following requirements:
      <ol type="a">
        <li>The act is an act of terrorism.</li>
        <li>The act is violent or dangerous to human life, property, or infrastructure.</li>
        <li>
          The act resulted in damage within the United States, or outside the United States 
          in the case of certain premises of United States missions or certain air carriers or vessels.
        </li>
        <li>
          The act has been committed by an individual or individuals as part of an effort to coerce 
          the civilian population of the United States or to influence the policy or affect the conduct 
          of the United States Government by coercion. 
        </li>
      </ol>
    </P>
    <P>Coverage under your policy is affected as follows:</P>
    <P>
      For property located in standard fire policy states, there are state statutory exceptions covering certain fire losses 
      if you decline coverage for “acts of terrorism” defined under the Act.  
      If an “act of terrorism” certified under the Act results in fire, we are required to pay for the loss or damage caused by that fire.  
      Such coverage for fire applies only to direct loss or damage by fire to covered property and is subject to any limitations 
      of any terrorism exclusion, or inapplicability or omission of a terrorism exclusion.  
      This notice does not serve to create coverage for any loss which would otherwise be excluded under your policy.
    </P>
    <P>
      The portion of your premium that is attributable to coverage for
      direct loss or damage that is caused by an “act of terrorism”
      certified under the Act and where fire ensues is
      <span>${{ triaPremium }}</span>, and does not include any charges for the portion of losses
      covered by the United States Government under the Act. Note, this
      premium is applied to your policy regardless if you accept or
      decline coverage for “acts of terrorism” below.
    </P>
    <P>
      You should know that where coverage is provided by this policy for losses 
      resulting from certified acts of terrorism, such losses may be partially 
      reimbursed by the United States Government under a formula established by 
      federal law. However, your policy may contain other exclusions which might 
      affect your coverage, such as an exclusion for nuclear events. Under the 
      formula, the United States Government reimburses 80% of such Insured losses, 
      beginning on January 1, 2021 through December 31, 2027, exceeding the statutorily 
      established deductible paid by the insurance company providing the coverage. 
      The premium charged for this coverage is provided below and does not include 
      any charges for the portion of loss that may be covered by the 
      Federal Government under the Act.
    </P>
    <P>
      You should also know that the Act, contains a $100 billion cap that limits
       U.S. Government reimbursement as well as insurers’ liability for losses 
       resulting from certified acts of terrorism when the amount of such losses 
       in any one calendar year exceeds $100 billion. If the aggregate insured 
       losses for all insurers exceed $100 billion, your coverage may be reduced.
    </P>
    <FormGroup>
      <RadioButtons
        :value="terrorismCoverage"
        name="terrorismCoverage"
        label
        @change="triaChange($event)"
        :items="terrorismCoverage_array"
        :error="errors['tria_radio']"
        @resolve-error="errors['tria_radio'] = ''"
      />
    </FormGroup>
    <div class="button-group">
      <Button class="transparent" @click="prev">Back</Button>
      <Button class="red" @click="checkForm">Continue</Button>
    </div>
  </div>
</template>

<script>
import { FormHeading, Button, P, RadioButtons, FormGroup } from "../../style";
import { addCommaToNumber, scrollTop } from "../../utils";
export default {
  name: "TerrorismInsurance",
  props: {
    step: {
      type: Number,
      required: true
    },
    properties: {
      type: Array,
      default: () => []
    },
    payment: {
      type: Object,
      default: () => {}
    },
    triaItem: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    FormHeading,
    Button,
    P,
    RadioButtons,
    FormGroup
  },
  mounted() {
    scrollTop();
    this.$emit("set-premium", Math.round(this.triaPremium));
  },
  data() {
    return {
      terrorismCoverage: this.triaItem.triaCoverage
        ? this.triaItem.triaCoverage
        : {},
      errors: {
        tria_radio: ""
      }
    };
  },
  methods: {
    next() {
      const triaItem = {
        triaPremium: this.triaPremium,
        triaCoverage: this.terrorismCoverage
      };
      this.$emit("format-property", triaItem);
      this.$emit("next-step");
    },
    prev() {
      this.$emit("prev-step");
    },
    addComma(price) {
      return addCommaToNumber(price);
    },
    triaChange($event) {
      this.terrorismCoverage = $event;
      this.$emit("set-tria", $event.row_val);
      if ($event.row_val == 1) {
        this.$emit("set-premium", Math.round(this.triaPremium));
      } else {
        this.$emit("set-premium", 0);
      }
    },
    checkForm() {
      let preventSubmit = false;
      if (Object.keys(this.terrorismCoverage).length === 0) {
        this.errors["tria_radio"] =
          "Please select if you want to avail the insurance.";
        document.getElementsByClassName("radio")[0].scrollIntoView({behavior: "smooth", block: "center"});
        preventSubmit = true;
      }
      if (!preventSubmit) {
        this.next();
      }
    }
  },
  computed: {
    terrorismCoverage_array() {
      return [
        {
          value: "terrorismCoverage_yes",
          row_val: 1,
          display:
            '<p style="margin: 0;font-weight:bold;">Buy Terrorism Insurance</p> I hereby elect to purchase terrorism coverage, subject to the limitations of the Act, for acts of terrorism as defined above for a premium of <span style="font-weight:bold;">$' +
            Math.round(this.triaPremium) +
            "</span>."
        },
        {
          value: "terrorismCoverage_no",
          row_val: 0,
          display:
            '<p style="margin: 0;font-weight:bold;">Decline Terrorism Insurance</p> I hereby decline to purchase terrorism coverage for certified acts of terrorism. I understand that I will have no coverage for losses resulting from certified acts of terrorism.'
        }
      ];
    },
    premium() {
      return this.payment.yearlyPremium;
    },
    triaPremium() {
      let tria = 0;
      switch (this.properties[0].locationState) {
      case "MA":
        tria = this.premium * 0.028;
        break;
      case "NY":
        tria = this.premium * 0.03;
        break;
      case "ME":
        tria = this.premium * 0.01;
        break;
      case "CT":
        tria = this.premium * 0.028;
        break;
      case "NH":
        tria = this.premium * 0.013;
        break;
      case "RI":
        tria = this.premium * 0.025;
        break;
      case "VT":
        tria = this.premium * 0.008;
      }
      return addCommaToNumber(Math.round(tria));
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/style/_variables.scss";
.button-group {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  button:last-of-type {
    margin-left: $padding-lg;
  }
}
span {
  font-weight: 700;
}
</style>
